





































import { NextLoadSuggestionsSortBy } from '@/services/models/marketplace-service-model'
import { mapGetters, mapActions } from 'vuex'
import NextLoadSuggestionRow from './NextLoadSuggestionRow.vue'
import { SEGMENT_EVENTS, trackEvent } from '@/analytics/segment'

export default {
  components: {
    NextLoadSuggestionRow
  },
  props: {
    orderId: { type: Number, required: false, default: null }
  },
  data() {
    return {
      loadingInitially: true,
      sortBy: NextLoadSuggestionsSortBy.Nearest as NextLoadSuggestionsSortBy
    }
  },
  computed: {
    ...mapGetters(['contactInfo', 'nextLoadSuggestions', 'currentUser']),
    hasNextSuggestedLoads(): boolean {
      return this.nextLoadSuggestions && this.nextLoadSuggestions.length
    },
    hasMoreThenThreeSuggestions(): boolean {
      return this.nextLoadSuggestions && this.nextLoadSuggestions.length > 3
    }
  },
  async mounted() {
    if (this.orderId) {
      try {
        // NOTE: sortBy is for A/B testing purposes.
        this.sortBy =
          this.currentUser?.id % 2 === 0
            ? NextLoadSuggestionsSortBy.Nearest
            : NextLoadSuggestionsSortBy.Earliest

        await this.nextLoadSuggestionsByOrderId(this.orderId, this.sortBy)
      } catch (err) {
        //TODO: log an event
      } finally {
        this.loadingInitially = false
      }
    }
  },
  methods: {
    ...mapActions(['nextLoadSuggestionsByOrderId']),
    redirectToODV(orderId: number): void {
      trackEvent(SEGMENT_EVENTS.MAO_NLS_OPENED, {
        sortBy: this.sortBy, // NOTE: This is for the A/B testing phase
        numberOfNLS: this.nextLoadSuggestions.length,
        acceptedOrderId: this.orderId,
        nlsId: orderId,
        user: this.currentUser.id
      })

      this.$emit('openOrderDetails', orderId, this.sortBy)
    }
  }
}
